import type { AgentComponent } from '@reach/shared-types/agent-components';
import { useId } from 'react';
import { TenantPreviewItem } from './TenantPreviewItem';
import styles from './TenantPreviewSection.module.css';

interface TenantPreviewSectionProps {
  title: string;
  description: string;
  components: AgentComponent[];
  partnerName: string | undefined;
}

export const TenantPreviewSection = ({
  title,
  description,
  components,
  partnerName,
}: TenantPreviewSectionProps) => {
  const headingId = useId();
  const sectionIsEmpty = components.length === 0;

  if (sectionIsEmpty) {
    return null;
  }
  return (
    <section className={styles.tenantPreviewSection} aria-labelledby={headingId}>
      <h3 id={headingId}>{title}</h3>
      <p>{description}</p>
      <ul>
        {components.map(component => (
          <TenantPreviewItem key={component.id} component={component} partnerName={partnerName} />
        ))}
      </ul>
    </section>
  );
};
